import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const MagneticButton = ({ children, className = "btn-gold", onClick, testid, type = "button", disabled }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 220, damping: 16 });
  const sy = useSpring(y, { stiffness: 220, damping: 16 });
  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * 0.25);
    y.set((e.clientY - r.top - r.height / 2) * 0.3);
  };
  const click = (e) => {
    const r = ref.current.getBoundingClientRect();
    const s = document.createElement("span");
    const d = Math.max(r.width, r.height);
    s.className = "ripple";
    s.style.cssText = `width:${d}px;height:${d}px;left:${e.clientX - r.left - d / 2}px;top:${e.clientY - r.top - d / 2}px`;
    ref.current.appendChild(s);
    setTimeout(() => s.remove(), 700);
    onClick && onClick(e);
  };
  return (
    <motion.button ref={ref} type={type} disabled={disabled} style={{ x: sx, y: sy }} onMouseMove={move} onMouseLeave={() => { x.set(0); y.set(0); }}
      onClick={click} className={`${className} disabled:opacity-60`} data-testid={testid} whileTap={{ scale: 0.97 }}>
      {children}
    </motion.button>
  );
};
